import apiClient from '../../../shared/api/client';

function ensureArray(data) {
  if (Array.isArray(data)) {
    return data;
  }

  if (data && typeof data === 'object' && Array.isArray(data.data)) {
    return data.data;
  }

  return [];
}

function mapSettledResult(result, errorMessage, errors) {
  if (result?.status === 'fulfilled') {
    return ensureArray(result.value?.data);
  }

  errors.push(errorMessage);

  if (result?.status === 'rejected') {
    // eslint-disable-next-line no-console
    console.error(`Dashboard: fallo al cargar ${errorMessage}`, result.reason);
  }

  return [];
}

export async function fetchDashboardData() {
  const errors = [];

  const results = await Promise.allSettled([
    apiClient.get('/pacientes/actives'),
    apiClient.get('/pacientes'),
    apiClient.get('/entrevistas'),
    apiClient.get('/capacidad'),
    apiClient.get('/valoracion'),
    apiClient.get('/medidas'),
    apiClient.get('/encoder'),
    apiClient.get('/cuestionario'),
    apiClient.get('/users'),
  ]);

  const [
    activePatientsRes,
    allPatientsRes,
    entrevistasRes,
    capacidadRes,
    valoracionRes,
    medidasRes,
    encoderRes,
    cuestionariosRes,
    usersRes,
  ] = results;

  const payload = {
    activePatients: mapSettledResult(activePatientsRes, 'No se pudieron cargar los pacientes activos.', errors),
    allPatients: mapSettledResult(allPatientsRes, 'No se pudieron cargar los pacientes totales.', errors),
    entrevistas: mapSettledResult(entrevistasRes, 'No se pudieron cargar las entrevistas.', errors),
    capacidades: mapSettledResult(capacidadRes, 'No se pudieron cargar los informes SPPB/TUG.', errors),
    valoraciones: mapSettledResult(valoracionRes, 'No se pudieron cargar las valoraciones funcionales.', errors),
    medidas: mapSettledResult(medidasRes, 'No se pudieron cargar las medidas antropometricas.', errors),
    encoders: mapSettledResult(encoderRes, 'No se pudieron cargar los registros de encoder.', errors),
    cuestionarios: mapSettledResult(cuestionariosRes, 'No se pudieron cargar los cuestionarios.', errors),
    users: mapSettledResult(usersRes, 'No se pudieron cargar los usuarios.', errors),
    hasUsersData: usersRes?.status === 'fulfilled',
  };

  return { payload, errors };
}
